import * as model from "@/model/prd/qualityMgt/qualityItemConfig/QualityItemDetails";
import router from "@/router/index";
import {
    newEntityStoreHelper
} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.QualityItemDetails(), newFilter)
    .withStates({
        idReport: 2,
        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd",
        qualityItemStatus: '',

    }) //TODO load at the application start
    .withActions({
        qualityItemStatus(context, entity) {

            context.state.qualityItemStatus = entity;

        },
        Save(context, entity) {

            context.state.entity.itemId = context.state.qualityItemStatus.id;
            context.dispatch("api/post", {
                    url: context.state.baseModuleUrl + "/" + entity + "/saveQualityItemDetails",
                    data: context.state.entity
                }, {
                    root: true
                })
                .then(function () {
                    context.dispatch("base/showSuccess", {
                        userAlertSuccessStr: "Sucess!",
                        dismissCountDown: 5,
                        userAlertSuccessVisible: false,
                    }, {
                        root: true
                    }).then(function () {
                        context.dispatch("api/get", {
                                url: context.state.baseModuleUrl + "/qualityItemDetails" + "/findByItemCode/" + context.state.qualityItemStatus.itemCode
                            }, {
                                root: true
                            })
                            .then(response => {

                                {

                                    context.commit('qualityItemDetails' + "/setRows", response, {
                                        root: true
                                    });
                                    router.push({
                                        path: '/prd/qualityItemDetails',
                                        query: {
                                            id: context.state.qualityItemStatus.id
                                        }
                                    });
                                }
                            });
                    })
                })



        },
        Delete(context) {

            context.state.entity.itemId = context.state.qualityItemStatus.id; //赋值ID
            var checkedItems = context.state["checkedItems"];
            if (checkedItems) {
                var params = 'id=' + checkedItems.join(',');

            }
            context.dispatch("api/delete", { //发送请求
                    url: context.state.baseModuleUrl + ("/qualityItemDetails" + "?" + params)
                }, {
                    root: true
                })
                .then(function () { // doing search again
                    context.dispatch("base/showSuccess", {
                        userAlertSuccessStr: "Deleted!",
                        dismissCountDown: 5,
                        userAlertSuccessVisible: false,
                    }, {
                        root: true
                    }).then(function () {
                        context.dispatch("api/get", {
                                url: context.state.baseModuleUrl + "/qualityItemDetails" + "/findByItemCode/" + context.state.qualityItemStatus.itemCode
                            }, {
                                root: true
                            })
                            .then(response => {

                                {

                                    context.commit('qualityItemDetails' + "/setRows", response, {
                                        root: true
                                    });
                                }
                            });
                    })
                });



        }
    })
    .buildStore()